import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../api'
import { UpdatePostDataType } from '../types'

const updatePost = async (post: UpdatePostDataType) => {
  const { data, error } = await supabase
    .from('posts')
    .update({
      description: post.description,
    })
    .eq('id', post.id)
    .select(`
      *,
      category:categories(*),
      profile:user_profiles (id, username),
      assets:assets!posts_assets (
        *,
        category:categories(*)
      )`)
    .single();

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useUpdatePost(data: UpdatePostDataType) {
  const queryClient = useQueryClient();
  return useMutation(() => updatePost(data), {
    onSuccess: async (newData) => {
      queryClient.setQueryData(['post', `${newData.id}`], newData)
      queryClient.invalidateQueries({ queryKey: ['posts'] })
      queryClient.invalidateQueries({ queryKey: ['users-posts'] })
      return newData
    },
  })
}
